import React from "react";

export const ServiceElement = ({children, serviceImg, serviceName, serviceText}) => {

  return (
    <>
    {children}
    <div id="services-element">
      <img src={serviceImg} alt="Not found" className="service-element-img" />
      <div className="img-footer">
        <h3 className="service-element-title">{serviceName}</h3>
      </div>
      <div className="service-element-description">
        <p className="service-element-pitch">{serviceText}</p>
      </div>
    </div>
    </>
  );
};
